module.exports = __webpack_public_path__ + "static/media/jan 2021.19a41b4b.svg";